import { ComponentPropsWithoutRef } from 'react';

function EyeIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="15px"
      height="11px"
      viewBox="0 0 15 11"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="leaderboard-eye-icon"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="um-/-leaderboard-/-1.3"
          transform="translate(-141, -251)"
          fill={props.fill ?? '#7FABEC'}
          fillRule="nonzero"
        >
          <g id="Group-9" transform="translate(74.9918, 142)">
            <path
              d="M73.2322503,115.569232 C72.6430214,115.569232 72.1635159,115.089727 72.1635159,114.500498 C72.1635159,113.911269 72.6430214,113.431763 73.2322503,113.431763 C73.8214792,113.431763 74.3009847,113.911269 74.3009847,114.500498 C74.3009847,115.089727 73.8214792,115.569232 73.2322503,115.569232 M73.2322503,112.006784 C71.8571454,112.006784 70.7385368,113.125393 70.7385368,114.500498 C70.7385368,115.875603 71.8571454,116.994211 73.2322503,116.994211 C74.6073552,116.994211 75.7259639,115.875603 75.7259639,114.500498 C75.7259639,113.125393 74.6073552,112.006784 73.2322503,112.006784 M73.3887843,118.061236 C70.3208041,118.132485 68.3194208,115.508386 67.6553805,114.497363 C68.3863949,113.353817 70.227468,111.012576 73.0760014,110.939902 C76.1318692,110.862241 78.1446523,113.492752 78.8086926,114.503775 C78.0783908,115.647321 76.2366052,117.988562 73.3887843,118.061236 M80.2628839,114.146105 C79.8083155,113.353817 77.2975022,109.3824 73.0396644,109.515636 C69.1010219,109.615384 66.8103679,113.085208 66.2019018,114.146105 C66.0757911,114.365552 66.0757911,114.635586 66.2019018,114.855033 C66.6500577,115.636634 69.0725223,119.48764 73.2498488,119.48764 C73.308273,119.48764 73.3666971,119.486927 73.4251213,119.485502 C77.3630512,119.385041 79.6544178,115.91593 80.2628839,114.855033 C80.3882821,114.635586 80.3882821,114.365552 80.2628839,114.146105"
              id="eye-open-icon"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default EyeIcon;
